import { useState } from 'react';
import { ArrowRight, MapPinCheck, UsersRound } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';
import { BrandLogo } from '../../components/BrandLogo';
import { InlineSpinner } from '../../components/LoadingIndicators';
import { ThemeToggle } from '../../components/ThemeToggle';
import { GoogleBaSignIn } from './GoogleBaSignIn';

export function LoginPage() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function submit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    const message = await signIn(email.trim(), password);
    if (!message) {
      void navigate('/', { replace: true });
      return;
    }
    setError(message);
    setSubmitting(false);
  }

  return (
    <main className="login-page">
      <ThemeToggle className="auth-theme-toggle" />
      <section className="login-story">
        <BrandLogo className="brand-logo-auth" variant="lockup" />
        <div>
          <p className="eyebrow">Field operations, made visible</p>
          <h1>Every shift.<br />Every sale.<br /><span>One clear view.</span></h1>
          <p className="story-copy">
            Staff campaigns, verify attendance, and understand field performance across Pakistan.
          </p>
        </div>
        <div className="story-points">
          <span><UsersRound size={18} /> Trusted talent pool</span>
          <span><MapPinCheck size={18} /> Location-verified attendance</span>
        </div>
      </section>

      <section className="login-panel">
        <GoogleBaSignIn />
        <form className="login-form" onSubmit={(event) => { void submit(event); }}>
          <p className="eyebrow">Welcome back</p>
          <h2>Sign in to your workspace</h2>
          <p className="muted">Phone OTP will be added after the pilot. Use your verified email.</p>

          <label>
            Email address
            <input
              autoComplete="email"
              inputMode="email"
              onChange={(event) => setEmail(event.target.value)}
              placeholder="name@company.com"
              required
              type="email"
              value={email}
            />
          </label>

          <label>
            <span className="auth-field-heading">Password <Link to="/forgot-password">Forgot password?</Link></span>
            <input
              aria-label="Password"
              autoComplete="current-password"
              minLength={8}
              onChange={(event) => setPassword(event.target.value)}
              required
              type="password"
              value={password}
            />
          </label>

          {error ? <p className="form-error" role="alert">{error}</p> : null}

          <button className="button primary full" disabled={submitting} type="submit">
            {submitting ? <InlineSpinner /> : null} {submitting ? 'Signing in…' : 'Sign in'} {!submitting ? <ArrowRight size={17} /> : null}
          </button>
          <p className="auth-register-link">New to BFC? <Link to="/register">Create your account</Link></p>
        </form>
      </section>
    </main>
  );
}
